import 'isomorphic-fetch'

import { footerEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

import {
  FETCH_FOOTER,
  FOOTER_ADD_STATUS,
  FOOTER_SAVE_END,
  FOOTER_SAVE_START,
  FOOTER_UPDATE_STATUS
} from '../actionTypes'

export const fetchFooterList = () => async dispatch => {
  const { method, url } = footerEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))

  const { footers = [] } = apiResponse || {}

  dispatch({
    type: FETCH_FOOTER,
    payload: {
      footers
    }
  })
}

export const addFooter = (footer, accessToken) => async dispatch => {
  const { method, url } = footerEndpoint.add
  const idToken = getIdToken()
  dispatch({ type: FOOTER_SAVE_START })

  const apiResponse = await fetch(url, {
    body: JSON.stringify({ footer }),
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => ({
      message: error.message,
      success: false
    }))

  const { success, message } = apiResponse
  dispatch({
    type: FOOTER_ADD_STATUS,
    payload: { message, success }
  })
  dispatch({ type: FOOTER_SAVE_END })
}

export const updateFooter = (footerObjectId, footer, accessToken) => async dispatch => {
  const { method, url } = footerEndpoint.update(footerObjectId)
  const idToken = getIdToken()
  dispatch({ type: FOOTER_SAVE_START })

  const apiResponse = await fetch(url, {
    body: JSON.stringify(footer),
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => ({
      message: error.message,
      success: false
    }))

  const { message, success } = apiResponse || {}
  dispatch({
    type: FOOTER_UPDATE_STATUS,
    payload: { message, success }
  })
  dispatch({ type: FOOTER_SAVE_END })
}

export const resetFooterStatus = () => async dispatch => {
  dispatch({
    type: FOOTER_UPDATE_STATUS,
    payload: {
      message: '',
      success: false
    }
  })
}
